export default __webpack_public_path__ + "static/keyboardNavigation-2d25cf05052e71c88b2b80954409a356.gif";